<template>
    <div class="relative self-stretch inline-block w-56 mr-6">
        <div
            class="flex rounded-md shadow-sm w-full h-full bg-white items-center mr-6 px-2 border border-gray-300 cursor-pointer mb-3"
            @click="open = !open"
            v-click-outside="
                () => {
                    open = false;
                }
            "
        >
            <div class="flex w-full">
                <svg
                    class="h-5 w-5 mx-1"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                >
                    <path fill="none" d="M0 0h24v24H0z" />
                    <path
                        d="M6.17 18a3.001 3.001 0 0 1 5.66 0H22v2H11.83a3.001 3.001 0 0 1-5.66 0H2v-2h4.17zm6-7a3.001 3.001 0 0 1 5.66 0H22v2h-4.17a3.001 3.001 0 0 1-5.66 0H2v-2h10.17zm-6-7a3.001 3.001 0 0 1 5.66 0H22v2H11.83a3.001 3.001 0 0 1-5.66 0H2V4h4.17zM9 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm6 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-6 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
                        fill="#ACB2BD"
                    />
                </svg>
                <span
                    class="text-sm leading-5 text-gray-400 font-extralight"
                    v-bind:class="{
                        'text-gray-700': !(
                            itemSelected === null && filterPicked === ''
                        )
                    }"
                    >{{
                        itemSelected === null && filterPicked === ""
                            ? placeholder
                            : itemSelected || filterPicked
                    }}</span
                >
            </div>
            <div
                class="flex justify-end"
                v-bind:class="{ 'transform rotate-180': open }"
            >
                <svg
                    class="h-2 w-3"
                    viewBox="0 0 10 6"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M5.00005 3.879L8.71255 0.166504L9.77305 1.227L5.00005 6L0.227051 1.227L1.28755 0.166504L5.00005 3.879Z"
                        fill="#ACB2BD"
                    />
                </svg>
            </div>
        </div>
        <transition
            enter-active-class="transition duration-100 ease-out"
            enter-class="transform scale-95 opacity-0"
            enter-to-class="transform scale-100 opacity-100"
            leave-active-class="transition duration-75 ease-in"
            leave-class="transform scale-100 opacity-100"
            leave-to-class="transform scale-95 opacity-0"
        >
            <div
                v-if="open"
                class="items absolute rounded-md shadow-sm w-full bg-white items-center mr-6 px-2 border border-gray-300 cursor-pointer"
            >
                <div class="py-1" role="none">
                    <span
                        class="
                                block
                                px-4
                                py-2
                                cursor-pointer
                                text-sm text-gray-400
                                hover:bg-gray-100
                                hover:text-gray-900
                            "
                        role="menuitem"
                        @click="itemClicked('')"
                        >Desactiver Filtre</span
                    >
                    <span
                        v-for="item in items"
                        :key="item"
                        class="
                                block
                                px-4
                                py-2
                                cursor-pointer
                                text-sm text-gray-700
                                hover:bg-gray-100
                                hover:text-gray-900
                            "
                        role="menuitem"
                        @click="itemClicked(item)"
                        >{{ item }}</span
                    >
                </div>
            </div></transition
        >
    </div>
</template>

<script>
export default {
    data() {
        return {
            itemSelected: null,
            open: false
        };
    },
    props: {
        placeholder: {
            type: String,
            required: true
        },
        items: {
            type: Array,
            required: true
        },
        filterPicked: {
            type: String
        }
    },
    methods: {
        itemClicked(item) {
            this.itemSelected = item == "" ? null : item;
            this.$emit("selectItemClicked", item);

            this.open = false;
        }
    }
};
</script>

<style></style>
